import { create } from "zustand";

export interface UploadedFile {
  id: string;
  file: File;
  name: string;
  size: number;
  type: string;
  uploadStatus: "pending" | "uploading" | "completed" | "error";
  fileUrl?: string;
  error?: string;
  collection_name?: string; // Collection name from upload response
}

interface FileUploadStore {
  attachedFiles: UploadedFile[];
  ragCollectionNames: string[];
  setAttachedFiles: (files: UploadedFile[]) => void;
  addAttachedFile: (file: UploadedFile) => void;
  removeAttachedFile: (id: string) => void;
  updateFileUploadStatus: (
    id: string,
    status: UploadedFile["uploadStatus"],
    fileUrl?: string,
    error?: string,
    collection_name?: string
  ) => void;
  clearAttachedFiles: () => void;
  setRagCollectionNames: (collectionNames: string[]) => void;
  clearRagCollectionNames: () => void;
  removeRagCollectionName: (collectionName: string) => void;
}

const useFileUploadStore = create<FileUploadStore>((set) => ({
  attachedFiles: [],
  ragCollectionNames: [],
  setAttachedFiles: (files) => set({ attachedFiles: files }),
  addAttachedFile: (file) =>
    set((state) => ({
      attachedFiles: [...state.attachedFiles, file],
    })),
  removeAttachedFile: (id) =>
    set((state) => ({
      attachedFiles: state.attachedFiles.filter((file) => file.id !== id),
    })),
  updateFileUploadStatus: (id, status, fileUrl, error, collection_name) =>
    set((state) => ({
      attachedFiles: state.attachedFiles.map((file) =>
        file.id === id
          ? { ...file, uploadStatus: status, fileUrl, error, collection_name }
          : file
      ),
    })),
  clearAttachedFiles: () => set({ attachedFiles: [] }),
  setRagCollectionNames: (collectionNames) => set({ ragCollectionNames: collectionNames }),
  clearRagCollectionNames: () => set({ ragCollectionNames: [] }),
  removeRagCollectionName: (collectionName) =>
    set((state) => ({
      ragCollectionNames: state.ragCollectionNames.filter(
        (name) => name !== collectionName
      ),
    })),
}));

export default useFileUploadStore;

